module.exports = __webpack_public_path__ + "static/media/youtube.b427b50f.svg";